<template>
  <v-card>
    <div class="text-left mx-3 my-3" style="font-size: 16px; font-weight: 700">
      Thông tin combo
    </div>

    <div v-if="productCombo" class="text-left mx-3 my-2">
      Combo <strong>{{ productCombo.name }}</strong> bao gồm
      <span style="color: #5d62d1; font-weight: 500">{{ productCombo.items.length }}</span> sản phẩm
    </div>
    <div class="px-3 pt-2">
      <v-simple-table fixed-header height="300px" class="table-blunk">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left font-weight-bold" style="font-size: 14px !important;">Tên sản phẩm</th>
            <th class="text-center font-weight-bold"  style="font-size: 14px !important;">Còn lại</th>
            <th class="text-center font-weight-bold"  style="font-size: 14px !important;">Muốn chuyển</th>
            <th class="text-center font-weight-bold"  style="font-size: 14px !important;">Đơn giá</th>
            <th class="text-center font-weight-bold"  style="font-size: 14px !important;width: 180px !important;max-width: 180px !important;">Thành tiền</th>
          </tr>
          </thead>
          <tbody v-if="productCombo && productCombo.items.length > 0">
          <tr v-for="(product, index) in productCombo.items" :key="'SkuDuos' + index">
            <td>{{ product.name }}</td>
            <td class="text-center">
              {{product.numberLessonRemaining}}
              <span v-if="product.productType === 'sku_duo'"> tháng</span>
              <span v-else> buổi</span>
            </td>
            <td class="text-center">
              <div v-if="!isDetail" class="d-flex align-center justify-center" style="column-gap: 8px;">
                <v-text-field
                    label=""
                    placeholder="Nhập số"
                    dense
                    :min="1"
                    :max="product.numberLessonRemaining"
                    type="number"
                    @input="handleNumberLessonTransferChange(product, index)"
                    :disabled="!product.isEditTransfer"
                    v-model="product.numberLessonTransfer"
                    style="max-width: 80px;"
                ></v-text-field>
                <span v-if="product.productType === 'sku_duo'"> tháng</span>
                <span v-else> buổi</span>
                <v-tooltip v-if="!product.isEditTransfer" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEditTransfer(product, index)" color="#5D62D1" icon small v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                  <span>Chỉnh sửa số buổi/tháng</span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEditTransfer(product, index)" icon small v-on="on"><v-icon>mdi-close-circle</v-icon></v-btn>
                  </template>
                  <span>Hủy bỏ</span>
                </v-tooltip>
              </div>
              <div v-else>
                {{ product.numberLessonTransfer }}
                <span v-if="product.productType === 'sku_duo'"> tháng</span>
                <span v-else> buổi</span>
              </div>
            </td>
            <td class="text-center">
              {{ (!isDetail && productCombo.orderTypeProduct ===  2 ) || (isDetail && productCombo.priceType ===  2 )? (product.price ? formatCurrencyNoD_C(product.price) : 0)
                : (product.priceDeposit ? formatCurrencyNoD_C(product.priceDeposit) : 0) }} đ
            </td>
            <td class="text-center">
              <div v-if="!isDetail &&  product.productType !== 'sku_tutor'" class="d-flex" style="column-gap: 12px;">
                <v-text-field
                    v-if="productCombo.orderTypeProduct === 2 "
                    label=""
                    placeholder="Nhập thành tiền"
                    dense
                    :min="1"
                    type="number"
                    @input="product.intoMoney = product.intoMoney ?  product.intoMoney.replace(/[^0-9.]/g,'') : null"
                    :disabled="!product.isEdit"
                    v-model="product.intoMoney"
                ></v-text-field>
                <v-text-field
                    v-else
                    label=""
                    placeholder="Nhập thành tiền"
                    dense
                    :min="1"
                    type="number"
                    @input="product.intoMoneyDeposit = product.intoMoneyDeposit ?  product.intoMoneyDeposit.replace(/[^0-9.]/g,'') : null"
                    :disabled="!product.isEdit"
                    v-model="product.intoMoneyDeposit"
                ></v-text-field>
                <v-tooltip v-if="!product.isEdit && product.productType !== 'sku_tutor'" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEdit(product)" color="#5D62D1" icon small v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                  <span>Chỉnh sửa thành tiền</span>
                </v-tooltip>
                <v-tooltip v-if="product.isEdit && product.productType !== 'sku_tutor'" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEdit(product)" icon small v-on="on"><v-icon>mdi-close-circle</v-icon></v-btn>
                  </template>
                  <span>Hủy bỏ</span>
                </v-tooltip>
              </div>
              <div v-else>
                {{ (!isDetail && productCombo.orderTypeProduct ===  2 ) || (isDetail && productCombo.priceType ===  2 )? formatCurrencyNoD_C(product.intoMoney) : formatCurrencyNoD_C(product.intoMoneyDeposit) }} đ
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="4" class="text-center">Không có dữ liệu</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="d-flex justify-end px-3 py-2">
      <v-btn class="btn-blunk" text @click="$emit('onSavePrice',  productCombo.productId)"> {{ isDetail ? 'Thoát' : 'Lưu' }} </v-btn>
    </div>
  </v-card>
</template>

<script>
import {formatCurrencyNoD_C} from "../../helper/FuncProduct";
import _ from "lodash";
import TransferRepository from "../../repository/TransferRepository";

export default {
  name: 'DetailComboSubModule',
  props: {
    productCombo: {
      type: Object,
      required: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
    urlCRM: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isEdit: false,
      productClone: {},
    }
  },
  methods: {
    formatCurrencyNoD_C,
    handleEdit(product) {
      if (!product.isEdit) {
        product.isEdit = true
      }else {
        product.isEdit = false
      }
    },
    handleEditTransfer(product) {
      if (!product.isEditTransfer) {
        product.isEditTransfer = true
      }else {
        product.isEditTransfer = false
        product.numberLessonTransfer = product.originalNumberLessonTransfer;
        product.intoMoney = product.originalIntoMoney;
        product.intoMoneyDeposit = product.originalIntoMoneyDeposit;
      }
    },
    handleNumberLessonTransferChange: _.debounce(async function (product, index) {
      this.productCombo.items[index].numberLessonTransfer = this.productCombo.items[index].numberLessonTransfer ?
          this.productCombo.items[index].numberLessonTransfer.replace(/[^0-9.]/g,'') : null
      if (this.productCombo.items[index].numberLessonTransfer &&
          parseInt(this.productCombo.items[index].numberLessonTransfer) > this.productCombo.items[index].numberLessonRemaining) {
        this.productCombo.items[index].numberLessonTransfer = _.cloneDeep(this.productCombo.items[index].numberLessonRemaining);
        return
      }
      if(this.productCombo.items[index].numberLessonTransfer !== null &&
          this.productCombo.items[index].numberLessonTransfer !== '' &&
          this.orderId) {
        const params = {
          orderProductId: this.productCombo.items[index].orderProductId,
          numberLessonTransfer: this.productCombo.items[index].numberLessonTransfer,
          isCalcUnusedReceiptAmount: this.productCombo.items[index].isCalcUnusedReceiptAmount,
          orderId: this.orderId,
        }
        try {
          const response = await TransferRepository.getIntoMoneyPaymentReceiptApi(this.urlCRM,params)
          if (response.success) {
            if (this.productCombo.orderTypeProduct === 1) {
              this.productCombo.items[index].intoMoneyDeposit = response.data && response.data.intoMoneyDeposit ? response.data.intoMoneyDeposit : 0;
            } else if (this.productCombo.orderTypeProduct === 2) {
              this.productCombo.items[index].intoMoney = response.data && response.data.intoMoney ? response.data.intoMoney : 0;
            }
          }
        } catch (error) {
          console.error('Error calling API:', error);
        }
      }
    }, 500),
  },
};
</script>
<style lang="scss" scoped>
.btn-blunk {
  background-color: #5d62d1 !important;
  color: #fff !important;
}
::v-deep input[type=number]::-webkit-inner-spin-button,
::v-deep input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Cho Firefox */
::v-deep input[type=number] {
  -moz-appearance: textfield;
}

::v-deep.v-input__control {
  min-height: 10px;
}
</style>
